<script lang="ts">
    import { onMount, onDestroy, createEventDispatcher } from "svelte"
    import { _ } from "svelte-i18n"
    import inputfields from "./inputfields"
    import { getOfferAssistantConfig } from "../../../../api"
    import { newNotification, showOfferAssistant } from "../../../../store"
    import Modal from "./../../../widgets/Modal.svelte"
    import MiniLoader from "../../../widgets/MiniLoader.svelte"
    import { RuleEngine } from "./RuleEngine"

    const dispatch = createEventDispatcher()

    export let currentChoices: {
        [context: string]: {
            code: number
            label: string
            labelLong?: string
            onSelect?: Function
        }
    } = {}
    let mappedCurrentChoices: { [key: string]: number } = {}
    let propertyMappings: { [key: string]: string } = {
        BK_Anzahl_Briefkasten: "Weh",
    }
    for (const prop in currentChoices) {
        if (propertyMappings[prop]) {
            mappedCurrentChoices[propertyMappings[prop]] = currentChoices[prop].code
        }
    }

    export let id: string
    export let ftpAssetsUrl: string
    export let configUrl: string = null
    export let show: boolean = false
    export let value: {
        [key: string]: any
    } = null
    export let reset: boolean = false

    let showWelcomeModal: boolean = true
    let configuration: OfferAssistantStep[]
    let configurationName: string
    let selected: string
    let stepsFinallyCompleted: {
        [key: string]: boolean
    } = {}
    let pending: boolean = true
    let configLoadingFailed: boolean = false
    const ruleEngine = new RuleEngine()
    let selectionInformationForDealers: string = ""

    const normalizedConfiguration: NormalizedConfiguration = {
        configuration: [],
    }

    if (!value) {
        value = (typeof window !== "undefined" && JSON.parse(window.localStorage.getItem(id))) || {}
    }

    onMount(async () => {
        configLoadingFailed = false

        if (configUrl) {
            getConfiguration("mailboxes")
        }
    })

    onDestroy(() => {
        $showOfferAssistant = false
    })

    const getConfiguration = (configName: string) => {
        pending = true
        configLoadingFailed = false

        getOfferAssistantConfig(configName)
            .then((response) => {
                console.log("------ offer assistant ----------------")
                configurationName = response.data[0].config.title
                configuration = response.data[0].config.steps
                selected = configuration[0].name
                if (typeof window !== "undefined") {
                    const lastConfigVersion = window.localStorage.getItem("offer-assistant-config-version")
                    console.log("lastConfigVersion", lastConfigVersion)
                    console.log("response.data[0].updateTime", response.data[0].updateTime)
                    if (lastConfigVersion !== response.data[0].updateTime) {
                        window.localStorage.setItem("offer-assistant-config-version", response.data[0].updateTime)
                        value = {}
                        resetOfferAssistant()
                        showWelcomeModal = true
                        console.log("offer assistant reseted because of other version")
                    }
                }
            })
            .catch((e) => {
                console.error(e)
                configLoadingFailed = true
            })
            .finally(() => {
                pending = false
            })
    }

    const onSelect = (e: CustomEvent) => {
        select(e.detail.name)
    }

    const select = (selectedItemName: string) => {
        selected = selectedItemName
    }

    const hasPrev = (): boolean => {
        for (let i = 0; i < configuration.length; i++) {
            if (configuration[i].name === selected) {
                if (i === 0) {
                    return false
                } else {
                    return true
                }
            }
        }
    }

    const hasNext = (): boolean => {
        for (let i = 0; i < configuration.length; i++) {
            if (configuration[i].name === selected) {
                if (configuration[i + 1]) {
                    return true
                } else {
                    return false
                }
            }
        }
    }

    const onBack = () => {
        for (let i = 0; i < configuration.length; i++) {
            if (configuration[i].name === selected) {
                let prevStepIndex = findPreviousDisplayedStepIndex(i)
                select(configuration[prevStepIndex].name)
                break
            }
        }
    }

    const findPreviousDisplayedStepIndex = (stepIndex: number): number => {
        let index = stepIndex

        while (true) {
            index--

            if (configuration[index].dependsOn && ruleEngine.resolve(configuration[index].dependsOn, value)) {
                break
            } else if (!configuration[index].dependsOn) {
                break
            } else if (index < 1) {
                break
            }
        }

        return index
    }

    const onNext = () => {
        for (let i = 0; i < configuration.length; i++) {
            if (configuration[i].name === selected) {
                let nextStepIndex = findNextDisplayedStepIndex(i)
                select(configuration[nextStepIndex].name)
                break
            }
        }
    }

    const findNextDisplayedStepIndex = (stepIndex: number): number => {
        for (let i = stepIndex + 1; i < configuration.length; i++) {
            if (configuration[i].dependsOn && ruleEngine.resolve(configuration[i].dependsOn, value)) {
                return i
            } else if (!configuration[i].dependsOn && i < configuration.length) {
                return i
            }
        }
    }

    const removeSelections = (v: { [key: string]: any }) => {
        for (var prop in v) {
            if (typeof v[prop] === "object") {
                removeSelections(v[prop])
            } else if (Array.isArray(v[prop])) {
                v[prop] = []
            } else {
                v[prop] = null
            }
        }
        value = value
    }

    const isFinallyCompleted = (): boolean => {
        let completed: boolean = true

        configuration.forEach((field) => {
            if (ruleEngine.resolve(field.dependsOn, value) && !stepsFinallyCompleted[field.name]) {
                completed = false
            }
        })

        return completed
    }

    const sendInquiry = () => {
        normalizedConfiguration.configuration = []
        normalizeValueObject(value)

        selectionInformationForDealers = ""
        prepareSelectionsForDealers(configuration)
        dispatch("complete-inquiry", {
            id,
            configurationName: configurationName,
            dealerInformation: selectionInformationForDealers,
            configuration: normalizedConfiguration.configuration,
        })
    }

    const normalizeValueObject = (obj: { [key: string]: any }) => {
        for (var propertyName in obj) {
            if (obj.hasOwnProperty(propertyName)) {
                if (Array.isArray(obj[propertyName])) {
                    normalizedConfiguration.configuration.push({
                        cfgOpt: {
                            cfgOptName: propertyName,
                            cfgOptValue: obj[propertyName].join(";"),
                        },
                    })
                } else if (typeof obj[propertyName] === "object") {
                    normalizeValueObject(obj[propertyName])
                } else {
                    if (obj[propertyName]) {
                        normalizedConfiguration.configuration.push({
                            cfgOpt: {
                                cfgOptName: propertyName,
                                cfgOptValue: obj[propertyName],
                            },
                        })
                    }
                }
            }
        }
    }

    const resetOfferAssistant = () => {
        // Remove all selections in value object
        removeSelections(value)

        // Remove local storage item with all selections
        if (typeof window !== "undefined") {
            window.localStorage.removeItem(id)
        }

        // Property to trigger remove all selections from outside must be set to default
        reset = false

        // Select the first step again
        if (configuration) {
            select(configuration[0].name)
        }
    }

    const prepareSelectionsForDealers = (config: OfferAssistantField[]) => {
        for (var propertyName in config) {
            if (config.hasOwnProperty(propertyName)) {
                if (config[propertyName].subFields && config[propertyName].subFields.length) {
                    prepareSelectionsForDealers(config[propertyName].subFields)
                } else {
                    // Find selected value of an element
                    const selectedValue = findSelectionValue(config[propertyName].name, value)

                    if (selectedValue) {
                        // Output - Label
                        selectionInformationForDealers += config[propertyName].label + "<br/>"

                        if (!config[propertyName].choices) {
                            // Output - Radio or Input Value
                            selectionInformationForDealers += `> ${selectedValue} <br/><br/>`
                        } else {
                            if (Array.isArray(selectedValue)) {
                                // Output - Multiple Choices Selection
                                for (let i = 0; i < selectedValue.length; i++) {
                                    selectionInformationForDealers += `> ${getChoiceTitleById(
                                        selectedValue[i],
                                        config[propertyName].choices
                                    )} <br/>`
                                }

                                selectionInformationForDealers += `<br/>`
                            } else {
                                // Output - Choices Selection
                                selectionInformationForDealers += `> ${getChoiceTitleById(
                                    selectedValue,
                                    config[propertyName].choices
                                )} <br/><br/>`
                            }
                        }
                    }
                }
            }
        }
    }

    const findSelectionValue = (name: string, v: { [key: string]: any }): string | number => {
        let foundValue = null

        for (var property in v) {
            if (!foundValue) {
                if (property === name) {
                    return v[property]
                } else if (typeof v[property] === "object") {
                    foundValue = findSelectionValue(name, v[property])
                }
            }
        }

        return foundValue
    }

    const getChoiceTitleById = (id: string | number, choices: OfferAssistantChoice[]) => {
        for (let choice in choices) {
            if (choices[choice].id === id) {
                return choices[choice].title
            }
        }

        return null
    }

    $: {
        if (reset === true) {
            resetOfferAssistant()
        } else {
            if (typeof window !== "undefined") {
                // Update local storage item with all selections
                window.localStorage.setItem(id, JSON.stringify(value))
            }
        }
    }
</script>

{#if configLoadingFailed}
    <Modal show="{configLoadingFailed}" size="sm">
        <div slot="header">Fehler</div>
        <p>
            Es ist ein unerwarteter Fehler aufgetreten! Die Konfiguration konnte nicht geladen werden! Schließen Sie den
            Konfigurator und versuchen Sie es zu einem späteren Zeitpunkt erneut.
        </p>
        <div slot="footer">
            <button class="btn" on:click="{() => (show = false)}">Zurück zum Konfigurator</button>
        </div>
    </Modal>
{:else if pending || !configuration}
    <MiniLoader />
{:else if show && configuration}
    <div class="offer-assistent-component">
        <div class="offer-assistent">
            {#if configuration}
                {#each configuration as field}
                    <svelte:component
                        this="{inputfields[field.widget] || inputfields.default}"
                        {...field}
                        bind:value="{value[field.name]}"
                        selected="{field.name === selected}"
                        values="{value}"
                        on:select="{onSelect}"
                        on:completed="{(e) => {
                            stepsFinallyCompleted[field.name] = e.detail.completed
                        }}"
                        currentChoices="{mappedCurrentChoices}"
                        {ftpAssetsUrl}
                    />
                {/each}
            {/if}
        </div>
        {#key selected}
            {#key stepsFinallyCompleted}
                <div class="offer-assistent-actions">
                    <div>
                        {#if value}
                            <button
                                class="btn btn-secondary"
                                on:click="{() => {
                                    removeSelections(value)
                                    if (typeof window !== 'undefined') {
                                        window.localStorage.removeItem(id)
                                    }
                                }}">Alle Filter löschen</button
                            >
                        {/if}
                    </div>
                    {#if isFinallyCompleted()}
                        <button class="btn btn-primary" on:click="{sendInquiry}">
                            {$_("product-config.make-inquiry")}
                        </button>
                    {:else}
                        <div class="offer-assistent-navigation">
                            <button class="btn btn-secondary" disabled="{!hasPrev()}" on:click="{onBack}">Zurück</button
                            >
                            {#if hasNext()}
                                <button class="btn btn-secondary" disabled="{!hasNext()}" on:click="{onNext}"
                                    >Weiter</button
                                >
                            {:else}
                                <button
                                    class="btn btn-primary"
                                    on:click|stopPropagation|preventDefault="{() => {
                                        newNotification({
                                            class: 'error',
                                            html: `Bitte füllen Sie alle Schritte aus! Ein grüner Haken neben einem Schritt zeigt an, dass dieser abgeschlossen ist.`,
                                        })
                                    }}"
                                >
                                    {$_("product-config.make-inquiry")}
                                </button>
                            {/if}
                        </div>
                    {/if}
                </div>
            {/key}
        {/key}
    </div>
{/if}

<Modal show="{showWelcomeModal && !configLoadingFailed}" size="md">
    <div slot="header">
        {$_("offer-assistant.welcome-title")}
    </div>
    <p>
        {@html $_("offer-assistant.welcome-text")}
    </p>
    <div slot="footer">
        <button class="btn btn-secondary" on:click="{() => (showWelcomeModal = false)}">
            {$_("offer-assistant.ok")}
        </button>
    </div>
</Modal>
